import React from "react";
import { Link } from "react-router-dom";
import {
  FaPhoneAlt,
  FaClock,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Header = () => {
  const [searchQuery, setSearchQuery] = React.useState("");
  const [menuOpen, setMenuOpen] = React.useState(false);

  const handleSearch = (e) => {
    e.preventDefault();
    console.log("Search query:", searchQuery);
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <style>{`
        /* ── TOP BAR ──────────────────────────────────── */
        .top-bar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 40px;
          background: #ffffff;
          font-family: "Segoe UI", sans-serif;
          font-size: 14px;
        }

        .top-left img {
          height: 45px;
        }

        .top-right {
          display: flex;
          gap: 35px;
          align-items: center;
        }

        .info-item {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #1a3aa1;
          font-weight: 500;
        }

        .info-item span {
          color: #000;
          font-weight: 500;
        }

        /* ── NAVBAR ───────────────────────────────────── */
        .navbar {
          background: #0b1c6b;
          padding: 14px 40px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: relative;
          z-index: 1000;
        }

        .nav-links {
          display: flex;
          gap: 30px;
        }

        .nav-links a {
          color: #ffffff;
          text-decoration: none;
          font-size: 15px;
        }

        .nav-right {
          display: flex;
          align-items: center;
          gap: 20px;
        }

        .search-form {
          display: flex;
          align-items: center;
          gap: 8px;
          background: #ffffff;
          padding: 6px 12px;
          border-radius: 20px;
        }

        .search-form input {
          border: none;
          outline: none;
          padding: 4px;
          font-size: 14px;
          width: 150px;
        }

        .search-form button {
          background: none;
          border: none;
          color: #0b1c6b;
          cursor: pointer;
          font-size: 16px;
        }

        .give-btn {
          background: #e6ecff;
          color: #0b1c6b;
          border: none;
          padding: 8px 20px;
          border-radius: 20px;
          font-weight: 600;
          cursor: pointer;
        }

        /* ── HAMBURGER (hidden on desktop) ───────────── */
        .hamburger {
          display: none;
          flex-direction: column;
          justify-content: center;
          gap: 5px;
          background: none;
          border: none;
          cursor: pointer;
          padding: 4px;
          z-index: 1100;
          margin-left: auto;
        }

        .hamburger span {
          display: block;
          width: 26px;
          height: 2.5px;
          background: #ffffff;
          border-radius: 2px;
          transition: all 0.3s ease;
          transform-origin: center;
        }

        .hamburger.open span:nth-child(1) { transform: translateY(7.5px) rotate(45deg); }
        .hamburger.open span:nth-child(2) { opacity: 0; transform: scaleX(0); }
        .hamburger.open span:nth-child(3) { transform: translateY(-7.5px) rotate(-45deg); }

        /* ── MOBILE MENU DRAWER ───────────────────────── */
        .mobile-menu {
          display: none;
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          z-index: 999;
        }

        .mobile-menu.open {
          display: block;
        }

        /* backdrop */
        .mobile-menu-backdrop {
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.45);
          backdrop-filter: blur(2px);
        }

        /* drawer panel — slides from LEFT */
        .mobile-menu-panel {
          position: absolute;
          top: 0; left: 0;
          width: min(80vw, 320px);
          height: 100%;
          background: #0b1c6b;
          display: flex;
          flex-direction: column;
          transform: translateX(-100%);
          transition: transform 0.35s cubic-bezier(0.77,0,0.18,1);
          overflow-y: auto;
        }

        .mobile-menu.open .mobile-menu-panel {
          transform: translateX(0);
        }

        .mobile-menu-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 20px 24px;
          border-bottom: 1px solid rgba(255,255,255,0.12);
        }

        .mobile-menu-header img {
          height: 36px;
          filter: brightness(0) invert(1);
        }

        .mobile-close-btn {
          background: none;
          border: none;
          color: #fff;
          font-size: 1.5rem;
          cursor: pointer;
          line-height: 1;
          padding: 4px;
        }

        .mobile-nav-links {
          display: flex;
          flex-direction: column;
          padding: 16px 0;
          flex: 1;
        }

        .mobile-nav-links a {
          color: rgba(255,255,255,0.88);
          text-decoration: none;
          font-size: 1rem;
          font-family: "Segoe UI", sans-serif;
          font-weight: 500;
          padding: 13px 24px;
          border-bottom: 1px solid rgba(255,255,255,0.07);
          transition: background 0.2s, color 0.2s, padding-left 0.2s;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .mobile-nav-links a::before {
          content: '';
          display: inline-block;
          width: 5px; height: 5px;
          border-radius: 50%;
          background: #159EEC;
          flex-shrink: 0;
          opacity: 0;
          transition: opacity 0.2s;
        }

        .mobile-nav-links a:hover {
          background: rgba(21,158,236,0.12);
          color: #ffffff;
          padding-left: 32px;
        }

        .mobile-nav-links a:hover::before {
          opacity: 1;
        }

        .mobile-nav-actions {
          padding: 20px 24px 32px;
          display: flex;
          flex-direction: column;
          gap: 12px;
          border-top: 1px solid rgba(255,255,255,0.12);
        }

        .mobile-nav-actions .give-btn {
          width: 100%;
          padding: 12px 20px;
          border-radius: 10px;
          font-size: 0.95rem;
          text-align: center;
        }

        .mobile-nav-actions a {
          text-decoration: none;
        }

        .mobile-info {
          padding: 16px 24px 24px;
          border-top: 1px solid rgba(255,255,255,0.1);
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .mobile-info .info-item {
          color: rgba(255,255,255,0.65);
          font-size: 0.8rem;
        }

        .mobile-info .info-item span {
          color: rgba(255,255,255,0.5);
        }

        /* ── RESPONSIVE BREAKPOINTS ───────────────────── */
        @media (max-width: 1024px) {
          .top-right { gap: 20px; }
          .nav-links  { gap: 18px; }
          .nav-links a { font-size: 13px; }
        }

        @media (max-width: 768px) {
          /* top bar: logo only, hide info items */
          .top-bar {
            padding: 10px 16px;
          }
          .top-right {
            display: none;
          }

          /* navbar: center logo, hamburger on right */
          .navbar {
            padding: 12px 16px;
            justify-content: center;
            position: relative;
          }
          .nav-links  { display: none; }
          .nav-right  { display: none; }
          .hamburger  {
            display: flex;
            position: absolute;
            right: 16px;
            top: 50%;
            transform: translateY(-50%);
            margin-left: 0;
          }

          /* center the logo image in top-bar on mobile */
          .top-bar {
            justify-content: center;
          }
          .top-left {
            display: flex;
            justify-content: center;
          }
        }
      `}</style>

      {/* ── TOP BAR ──────────────────────────────────────── */}
      <div className="top-bar">
        <div className="top-left">
          <img src="/images/logo.png" alt="Church Logo" />
        </div>
        <div className="top-right">
          <div className="info-item">
            <FaPhoneAlt /> <span>JOIN US</span> (+256) 783359816
          </div>
          <div className="info-item">
            <FaClock /> <span>PRAYER HOURS</span> 10:00 - 00:00 Mon-Sat
          </div>
          <div className="info-item">
            <FaMapMarkerAlt /> <span>LOCATION</span> Naguru Go-Down
          </div>
        </div>
      </div>

      {/* ── NAVIGATION ───────────────────────────────────── */}
      <div className="navbar">
        <div className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/who-we-are">Who We Are</Link>
          <Link to="/ministry">Ministry Work</Link>
          <Link to="/pastor-messages">Pastor Messages</Link>
          <Link to="/events">Events</Link>
          <Link to="/blogs">Blogs</Link>
          <Link to="/testimonials">Testimonials</Link>
          <Link to="/gallery">Gallery</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="nav-right">
          <Link to="/church-services">
            <button className="give-btn">Church Services</button>
          </Link>
          <Link to="/join">
            <button className="give-btn">Join Us</button>
          </Link>
        </div>

        {/* Hamburger — mobile only */}
        <button
          className={`hamburger${menuOpen ? " open" : ""}`}
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* ── MOBILE DRAWER ────────────────────────────────── */}
      <div className={`mobile-menu${menuOpen ? " open" : ""}`}>
        {/* Backdrop — click to close */}
        <div className="mobile-menu-backdrop" onClick={closeMenu} />

        <div className="mobile-menu-panel">
          {/* Header */}
          <div className="mobile-menu-header">
            <img src="/images/logo.png" alt="Church Logo" />
            <button className="mobile-close-btn" onClick={closeMenu} aria-label="Close menu">✕</button>
          </div>

          {/* Nav links */}
          <nav className="mobile-nav-links">
            <Link to="/"                  onClick={closeMenu}>Home</Link>
            <Link to="/who-we-are"        onClick={closeMenu}>Who We Are</Link>
            <Link to="/ministry"          onClick={closeMenu}>Ministry Work</Link>
            <Link to="/pastor-messages"   onClick={closeMenu}>Pastor Messages</Link>
            <Link to="/events"            onClick={closeMenu}>Events</Link>
            <Link to="/blogs"              onClick={closeMenu}>Blog</Link>
            <Link to="/testimonials"      onClick={closeMenu}>Testimonials</Link>
            <Link to="/gallery"           onClick={closeMenu}>Gallery</Link>
            <Link to="/contact"           onClick={closeMenu}>Contact</Link>
            <a href="https://dashboard.gcc-inter.org" target="_blank" rel="noopener noreferrer">
              Login Now
            </a>
          </nav>

          {/* CTA buttons */}
          <div className="mobile-nav-actions">
            <Link to="/church-services" onClick={closeMenu}>
              <button className="give-btn">Church Services</button>
            </Link>
            <Link to="/join" onClick={closeMenu}>
              <button className="give-btn">Join Us</button>
            </Link>
          </div>

          {/* Contact info at bottom */}
          <div className="mobile-info">
            <div className="info-item"><FaPhoneAlt /> <span>JOIN US</span> (+256) 783359816</div>
            <div className="info-item"><FaClock /> <span>PRAYER HOURS</span> 10:00 - 00:00 Mon-Sat</div>
            <div className="info-item"><FaMapMarkerAlt /> <span>LOCATION</span> Naguru Go-Down</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;